import React from "react";
import logo from "common/assets/logo-with-name.webp";
import "../css/HomePage.css";

export default function BannerSection() {
    return (
        <div className="mtg-simple-header">
        <a href="/" className="mtg-logo"> <img src={logo} alt="Mentor Together logo" loading="lazy" decoding="async" /> </a>
        <div className="mtg-simple-actions">
          <a className="mtg-simple-btn" href="/signin" rel="noopener noreferrer">
            SIGN IN
          </a>
        </div>
      </div>
    );
}
